/* src/app/private/components/whatsapp-template/create-whatsapp-template/create-whatsapp-template.component.scss */
.text-label {
  font-weight: 600;
  font-size: 16px;
}
.sub_text {
  font-size: 14px;
  margin-top: 5px;
}
.sample_Card {
  width: 100%;
  border: 1px solid var(--secondry-light-gray);
  border-radius: 5px;
  padding: 15px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.left-box {
  overflow-y: auto;
}
.left-box::-webkit-scrollbar {
  width: 8px !important;
}
.left-box::-webkit-scrollbar-thumb {
  background-color: var(--secondry-light-gray) !important;
  border-radius: 0px !important;
}
.left-box::-webkit-scrollbar-track {
  background-color: transparent !important;
}
.category_item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
  border: 2px solid var(--secondry-light-gray);
}
.item_boxx {
  display: flex;
  gap: 10px;
  align-items: center;
}
.media_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  align-items: center;
  margin-top: 10px;
  border: 1px solid var(--secondry-light-gray);
  padding: 15px 10px;
  border-radius: 5px;
  width: 100%;
  cursor: pointer;
}
.media_box_image {
  font-size: 24px;
}
.media-box-action {
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
}
.media-box-preview-item {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.media-preview {
  width: 200px;
  height: 200px;
  object-fit: contain;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}
.media-box-action {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 34px;
  font-size: 18px;
}
.quickreply_button_container {
  display: flex;
  flex-direction: column;
  gap: 19px;
  margin-top: 24px;
  border: 1px solid var(--secondry-light-gray);
  width: 100%;
  padding-right: 100px;
  padding: 25px;
  padding-right: 100px;
  border-radius: 15px;
  padding-top: 0px;
  overflow: hidden;
}
.quickreply_button_container .quick_reply_heading {
  width: 138%;
  background: var(--primary-color);
  color: #fff;
  margin-left: -27px;
  padding: 7px;
  padding-left: 21px;
  font-size: 16px;
}
.quickreply_button_container .quick_reply_box {
  position: relative;
}
.quickreply_button_container .quick_reply_box:not(:last-child)::after {
  content: "";
  display: block;
  width: 113%;
  height: 1px;
  background: var(--secondry-light-gray);
  margin-top: 16px;
}
.right-side-box {
  height: 100%;
  overflow-y: auto;
}
.whatsapp-ui-box {
  background: url("./media/whatsappbg.png");
  border-radius: 20px;
  height: 100%;
  width: 100%;
  background-size: cover;
  padding: 20px 30px;
  position: relative;
}
.preview-box {
  background: #fff;
  border-radius: 6px;
  max-height: 90%;
  overflow-y: auto;
  word-break: break-all;
  z-index: 10;
  position: relative;
  margin-top: 16px;
  padding: 10px 10px;
}
.preview-box .header_Text {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #000;
}
.preview-box .body_Text {
  font-size: 13px;
  color: #000;
}
.preview-box::-webkit-scrollbar {
  width: 8px;
}
.preview-box::-webkit-scrollbar-thumb {
  background-color: var(--secondry-light-gray) !important;
  border-radius: 0px !important;
}
.preview-box::-webkit-scrollbar-track {
  background-color: transparent !important;
}
.timeText {
  display: flex;
  justify-content: flex-end;
  margin-top: 5px;
  font-size: 12px !important;
  margin-bottom: 7px;
  color: #000;
}
.footer_Text {
  font-size: 11px !important;
  opacity: 0.9 !important;
  margin-top: 6px;
  color: #000;
}
.action_icon {
  color: #297c86;
  font-size: 12px !important;
  font-weight: 600;
}
.action_text {
  color: #297c86;
  font-size: 12px !important;
  padding-top: 6px;
  padding-bottom: 5px;
  display: flex;
  justify-content: center;
  gap: 10px;
  align-items: center;
  font-weight: 600;
  letter-spacing: 0.6px;
}
.dark-overlay {
  display: block;
  height: 100%;
  width: max-content;
  background: rgba(0, 0, 0, 0.1294117647);
  z-index: 1;
  width: 100%;
  top: 0;
  left: 0;
}
.errors {
  font-size: 12px;
  color: red;
}
.body_Text p {
  margin-bottom: 0px;
}
/*# sourceMappingURL=create-whatsapp-template.component.css.map */
